import Link from './src/Link';

export default Link;
